@if (isFormLoading) {
  <div class="waiting-spinner">
    <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
    <p>{{ 'Loading...' }}</p>
  </div>
} @else {
  <mat-sidenav-container>
    <mat-sidenav-content>
      <div class="portal-page-content">
        <div fxLayout="row" fxLayoutAlign="start center">
          <h2 class="header mr-1">Forms</h2>
          <div fxLayout="row" fxLayoutAlign="flex-start center">
            <mat-icon>assignment_turned_in</mat-icon>
            <span class="form-count">
              {{ completedApplications.length }} submitted forms</span
            >
          </div>
        </div>

        @for (
          application of completedApplications;
          track application.applicationId
        ) {
          <mat-card class="form-card clickable" appearance="outlined">
            <mat-card-content>
              <div fxLayout="row">
                <mat-card-header
                  fxFlex="grow"
                  role="button"
                  tabindex="0"
                  [attr.aria-label]="
                    application.displayTitle +
                    ' ' +
                    application.getTeamNameSuffix() +
                    ', view form details'
                  "
                  (click)="openDetails(application, $event)"
                  (keydown.enter)="openDetails(application, $event)"
                  (keydown.space)="openDetails(application, $event)"
                >
                  <mat-card-title>
                    <span class="form-name"
                      >{{ application.displayTitle }}
                      {{ application.getTeamNameSuffix() }}</span
                    >
                  </mat-card-title>
                  <mat-card-subtitle>
                    <span class="date"
                      >Sent
                      {{ application.sentDate | date: 'mediumDate' }}</span
                    >
                  </mat-card-subtitle>
                  @if (application.formType == 'Application') {
                    <mat-chip class="mat-chip-title">Lineup Form</mat-chip>
                  } @else if (application.formType == 'Survey') {
                    <mat-chip class="mat-chip-title">Team Survey</mat-chip>
                  } @else if (application.formType == 'Team') {
                    <mat-chip class="mat-chip-title">Team Form</mat-chip>
                  }
                </mat-card-header>
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
    </mat-sidenav-content>
    <mat-sidenav
      [disableClose]="true"
      [autoFocus]="true"
      [opened]="isSideBarOpen"
      mode="over"
      position="end"
    >
      <app-portal-form-details
        (closed)="onPanelClosed()"
      ></app-portal-form-details>
    </mat-sidenav>
  </mat-sidenav-container>
}
